import { Divider, Link as MuiLink, Stack, Typography } from "@mui/material"
import React from "react"

export function Footer() {
  return (
    <>
      <Divider />
      <Stack
        direction={{ sm: "row", xs: "column" }}
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        gap={1}
      >
        <Typography variant="body2" color="text.secondary" textAlign="center">
          © 2023–{new Date().getFullYear()} Privatefolio. All rights reserved.
        </Typography>
        <Stack direction="row" gap={2}>
          <MuiLink href="/tos" variant="body2" color="text.secondary" underline="hover">
            Terms of Service
          </MuiLink>
          <MuiLink href="/privacy" variant="body2" color="text.secondary" underline="hover">
            Privacy Policy
          </MuiLink>
        </Stack>
      </Stack>
    </>
  )
}
